import SalesReportPage from "./SalesReportPage";

export {SalesReportPage}
export default SalesReportPage
